import React from 'react';
import { GuestDetails } from '../../types/booking';
export type GuestErrors = Partial<Record<'fullName' | 'email' | 'phone', string>>;
interface GuestDetailsFormProps {
  value: GuestDetails;
  errors: GuestErrors;
  onChange: (field: keyof GuestDetails, value: string) => void;
}
export function GuestDetailsForm({
  value,
  errors,
  onChange
}: GuestDetailsFormProps) {
  return <div className="grid gap-5 sm:grid-cols-2" data-id="element-113" data-mp="uiqvz7ie3snk">
      <div className="sm:col-span-2" data-id="element-114" data-mp="uhfy1obmlf4d">
        <Field id="fullName" label="Full name" value={value.fullName} error={errors.fullName} autoComplete="name" onChange={v => onChange('fullName', v)} data-id="element-115" data-mp="ugd57auqt2lt" />
      </div>
      <Field id="email" label="Email address" type="email" value={value.email} error={errors.email} autoComplete="email" onChange={v => onChange('email', v)} data-id="element-116" data-mp="lghpcsq8sjfg" />
      <Field id="phone" label="Phone number" type="tel" value={value.phone} error={errors.phone} autoComplete="tel" onChange={v => onChange('phone', v)} data-id="element-117" data-mp="368juc66uxlwa" />
      <div className="sm:col-span-2" data-id="element-118" data-mp="31b9t7ta3vlsm">
        <label htmlFor="specialRequests" className="block text-[11px] uppercase tracking-overline text-gold-700" data-id="element-119" data-mp="2j0sl8bpy6pb4">
          Special requests <span className="normal-case tracking-normal text-muted" data-id="element-120" data-mp="2nzvi38vrxp80">(optional)</span>
        </label>
        <textarea id="specialRequests" rows={3} value={value.specialRequests} onChange={event => onChange('specialRequests', event.target.value)} placeholder="Arrival time, celebration, crew details…" className="mt-2 w-full rounded-sm border-0 bg-ivory-50 p-3.5 text-[15px] text-ink ring-1 ring-forest-700/10 transition-shadow duration-150 placeholder:text-forest-300 focus:outline-none focus:ring-2 focus:ring-gold-400" data-id="element-121" data-mp="2a049xorxv31x" />
      </div>
    </div>;
}
function Field({
  id,
  label,
  value,
  onChange,
  error,
  type = 'text',
  autoComplete
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  type?: string;
  autoComplete?: string;
}) {
  return <div data-id="element-122" data-mp="3o0h2y135h0z4">
      <label htmlFor={id} className="block text-[11px] uppercase tracking-overline text-gold-700" data-id="element-123" data-mp="3o18yxd0nt0px">
        {label} <span aria-hidden="true" data-id="element-124" data-mp="3j8pebw3k15bm">*</span>
      </label>
      <input id={id} type={type} value={value} required autoComplete={autoComplete} onChange={event => onChange(event.target.value)} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : undefined} className={`mt-2 w-full rounded-sm border-0 bg-ivory-50 p-3.5 text-[15px] text-ink transition-shadow duration-150 focus:outline-none focus:ring-2 ${error ? 'ring-2 ring-danger-700/60 focus:ring-danger-700' : 'ring-1 ring-forest-700/10 focus:ring-gold-400'}`} data-id="element-125" data-mp="3f7nmi0byvvjo" />
      {error && <p id={`${id}-error`} role="alert" className="mt-2 text-[12px] text-danger-700" data-id="element-126" data-mp="2miyintjj1c48">
          {error}
        </p>}
    </div>;
}